export default __webpack_public_path__ + "static/heart-graffiti-539a68f34891692f947e491fa5b12bed.webp";